/**
 * @generated SignedSource<<486c56697e17ad5fecae39797091d298>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReportResolutionRefetchQuery$variables = {
  id: string;
};
export type ReportResolutionRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ReportResolution_report">;
  } | null;
};
export type ReportResolutionRefetchQuery = {
  variables: ReportResolutionRefetchQuery$variables;
  response: ReportResolutionRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportResolutionRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReportResolution_report"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReportResolutionRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reviewStatus",
                "storageKey": null
              },
              {
                "alias": "pendingResolutions",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "condition",
                    "value": {
                      "updateStatus": "pending"
                    }
                  }
                ],
                "concreteType": "ReportResolutionsConnection",
                "kind": "LinkedField",
                "name": "reportResolutions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  }
                ],
                "storageKey": "reportResolutions(condition:{\"updateStatus\":\"pending\"})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AnomalyCount",
                "kind": "LinkedField",
                "name": "anomalyCounts",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Report",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cc1731ef29118f68b72535743145c747",
    "id": null,
    "metadata": {},
    "name": "ReportResolutionRefetchQuery",
    "operationKind": "query",
    "text": "query ReportResolutionRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ReportResolution_report\n    id\n  }\n}\n\nfragment ReportResolution_report on Report {\n  id\n  reviewStatus\n  pendingResolutions: reportResolutions(condition: {updateStatus: \"pending\"}) {\n    totalCount\n  }\n  anomalyCounts {\n    type\n    count\n  }\n}\n"
  }
};
})();

(node as any).hash = "a89f316b391956c6a2a3694859fed56a";

export default node;
